import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from '../../helpers/BaseError';

import alternateKeys from 'hooks/alternates/_queryKeys';

import { UpdateVariantTypeInput } from '../../models/alternate.model';

import API from '../../services/api';

export default function useComponentTypeUpdate(
    formulaId: number,
    variantId: string,
) {
    const queryClient = useQueryClient();
    const alternatesKey = ['alternates', formulaId, variantId];
    return useMutation<AxiosResponse, BaseError, UpdateVariantTypeInput>({
        mutationFn: API.updateVariantType,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: alternatesKey,
            });
            queryClient.invalidateQueries({
                queryKey: alternateKeys.getVariantsByComponentId(variantId),
            });
        },
    });
}
